import React from 'react';

import {
  UiTypography,
  UiTypographyVariantType,
} from '@/components/ui/Typography';
import { LimitedTimerHoc } from '@/pages/Paywall/components/LimitedTimerHoc';

interface TimerTypographyProps {
  timeToExpire: number;
  textVariant?: UiTypographyVariantType;
}
export const TimerTypography: React.FC<TimerTypographyProps> = ({
  timeToExpire,
  textVariant = 'title-medium',
}) => {
  return (
    <LimitedTimerHoc timeToExpire={timeToExpire}>
      {({ minutes, seconds }) => (
        <UiTypography variant={textVariant}>
          {minutes}:{seconds}
        </UiTypography>
      )}
    </LimitedTimerHoc>
  );
};
